// View Keys 
export default {
  reportTypesModal_title: 'Report Types'
};